import { image1, image2, image3, image4 } from "../assests";
import { useState, useEffect } from "react";

const Banner = () => {
    const [num, setNum] = useState(0); // Start with 0 to use as index
    const [fade, setFade] = useState(true);
    const data = [image1, image2, image3, image4];

    // Function to change the image with a fade effect
    const changeImage = () => {
        setFade(false); // Start fading out
        setTimeout(() => {
            setNum((prevNum) => (prevNum + 1) % data.length); // Change image index
            setFade(true); // Start fading in
        }, 500); // Adjust this duration to match your CSS transition duration
    };

    // Automatically change the image every few seconds
    useEffect(() => {
        const interval = setInterval(changeImage, 3000); // Change image every 3 seconds
        return () => clearInterval(interval); // Clear interval on component unmount
    }, []);

    return (
        <div className="relative w-[100%] h-[88vh] overflow-x-hidden">
            <img
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${fade ? 'opacity-100' : 'opacity-0'}`}
                src={data[num]}
                alt={`img${num + 1}`}
            />
        </div>
    );
};

export default Banner;
